import React, { createContext } from 'react';

import { ICollectiveDirectoryPersonDrawerResponse } from 'interfaces';

export interface PeopleDrawerInfo {
  person: ICollectiveDirectoryPersonDrawerResponse | null;
  isCurrentUser: boolean;
  setShowContactDrawer: React.Dispatch<React.SetStateAction<boolean>>;
}

export const PeopleDrawerContext = createContext<PeopleDrawerInfo>({
  person: null,
  isCurrentUser: false,
  setShowContactDrawer: () => {},
});
